import { useState } from "react";
import { useChatWidgetContext } from "../../../providers/ChatWidgetProvider";
import Button from "../Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";

const ChatWidgetFooter = () => {
  const [messageText, setMessageText] = useState("");
  const { sentMessage } = useChatWidgetContext();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!messageText.trim()) return;
    sentMessage({ message: messageText });
    setMessageText("");
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="d-flex align-items-center gap-2">
        <div className="d-flex align-items-center flex-1 gap-3 border rounded-pill px-4">
          <Form.Control
            className="outline-none border-0 flex-1 fs--1 px-0"
            type="text"
            placeholder="Напишите ваш вопрос..."
            value={messageText}
            onChange={(e) => setMessageText(e.target.value)}
          />
        </div>
        <Button className="p-0 border-0 send-btn" type="submit">
          <FontAwesomeIcon icon={faPaperPlane} className="fs-9" />
        </Button>
      </div>
    </form>
  );
};

export default ChatWidgetFooter;
